export var max = Math.max;
export var min = Math.min;
export var round = Math.round;


//////////////////
// WEBPACK FOOTER
// /var/www/clients/client0/web6/deploy/releases/20230327134040/web/app/themes/metadieta/node_modules/@popperjs/core/lib/utils/math.js
// module id = 11
// module chunks = 0